<template>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%"
    border
    row-key="id"
    :height="height"
    @selection-change="handleSelectionChange"
  >
    <!-- 多选框 -->
    <el-table-column v-if="showCheckbox" width="55" type="selection">
    </el-table-column>
    <template v-for="(item, index) in columns">
      <!-- 默认 -->
      <el-table-column
        :key="index"
        v-if="item.field"
        :label="item.title"
        :prop="item.field"
        :width="item.width"
        sortable
      >
      </el-table-column>

      <!-- 默认 end -->
      <!-- 自定义 -->
      <el-table-column
        :label="item.title"
        :key="index + 'i'"
        :width="item.width"
        v-else
      >
        <template slot-scope="scope">
          <!-- <template > -->
          <!-- 上传图片 -->
          <!-- <el-upload
            v-if="item.type === 'upload'"
            :key="timer"
            :action="uploadFileUrl"
            list-type="picture-card"
            :file-list="uploadFileList"
            :on-remove="handleRemove"
            :on-success="handleSuccss"
            multiple
          >
            <i class="el-icon-plus" style="width: 20px; height: 20px" />
          </el-upload> -->
          <!-- tag标签 -->
          <div v-if="item.type == 'tag'" style="width: auto; overflow: auto">
            <el-tag
              type="danger"
              style="margin-top: 5px"
              v-for="(tag, index) in scope.row[item.payload.field]"
              :key="index"
              @close="handleClose(tag)"
              closable
              effect="dark"
              v-show="index < 4"
            >
              {{ tag.content }}
            </el-tag>
            <!-- 点击更多弹出 -->
            <el-popover placement="right" width="400" trigger="click">
              <div
                style="
                  border: 1px solid #ddd;
                  border-radius: 10px;
                  max-height: 200px;
                  overflow-y: auto;
                "
              >
                <el-tag
                  style="margin: 8px"
                  v-for="(tag, indexs) in scope.row[item.payload.field]"
                  :key="indexs + 'i'"
                  type="danger"
                  closable
                  effect="dark"
                  @close="handleClose(tag)"
                >
                  {{ tag.content }}
                </el-tag>
              </div>

              <el-tag
                slot="reference"
                type="danger"
                effect="dark"
                v-if="scope.row[item.payload.field].length >= 5"
                style="margin-top: 10px"
              >
                点击更多+{{ scope.row[item.payload.field].length - 4 }}
              </el-tag>
            </el-popover>
          </div>
          <el-upload
            :key="timer"
            v-if="item.type === 'upload'"
            action=""
            :http-request="uploadFn"
            :limit="1"
            :show-file-list="false"
          >
            <div
              @click="uploadClick(scope.row)"
              style="
                width: 100%;
                height: 100%;
                line-height: 80px;
                color: #409eff;
              "
            >
              选取文件
            </div>
            <!-- <i
              class="el-icon-plus"
              style="width: 20px; height: 20px"
              @click="uploadClick(scope.row)"
            /> -->
            <!-- <el-button
              size="small"
              type="success"
              @click="uploadClick(scope.row)"
              >选取文件</el-button
            > -->
          </el-upload>
          <!-- 图片预览 -->
          <!-- <el-popover
            placement="left"
            width="250"
            trigger="hover"
            v-if="item.type == 'photoPreview'"
          >
            <div>
              <img
                :src="getImgUrl(scope.row[item.payload.field])"
                style="width: 250px; height: 350px"
              />
            </div>

            <img
              slot="reference"
              :src="getImgUrl(scope.row[item.payload.field])"
              style="width: 100px; height: 100px"
              alt="image"
            />
          </el-popover> -->
          <!-- 图片预览 -->
          <el-popover
            placement="left"
            width="100"
            trigger="click"
            v-if="item.type == 'photoPreview'"
          >
            <div>
              <img
                v-if="scope.row[item.payload.field]"
                :src="getImgUrl(scope.row[item.payload.field])"
                style="width: 100px; height: 100px"
              />
            </div>

            <img
              v-if="scope.row[item.payload.field]"
              slot="reference"
              :src="getImgUrl(scope.row[item.payload.field])"
              style="width: 50px; height: 50px"
              alt="image"
            />
          </el-popover>
          <!-- 附件下载 -->
          <el-link
            type="primary"
            :href="
              'https://minisaasserver.jsjxtzjc.com/api/file' +
              scope.row[item.payload.field]
            "
            v-if="item.type == 'download'"
          >
            <span class="spanStyle" :title="scope.row[item.payload.field]"
              >下载</span
            >
          </el-link>
          <!-- 富文本 -->
          <div v-if="item.type == 'richText'">
            <span class="spanStyle" :title="scope.row[item.payload.field]">{{
              scope.row[item.payload.field]
            }}</span>
          </div>
          <!-- </template> -->
          <!-- switch v-model="scope.row.state" -->
          <el-switch
            v-if="item.type === 'switch'"
            :disabled="item.disabled"
            v-model="scope.row[item.payload.field]"
            @change="item.payload.change(scope.row)"
          >
          </el-switch>
          <!-- switch -->

          <!-- btn -->
          <template v-if="item.type === 'btn'">
            <el-button
              size="mini"
              plain
              :type="item.type"
              v-for="(item, index) in item.payload"
              :key="index"
              @click="item.click(scope.row)"
            >
              <span v-if="item.name">{{ item.name }}</span>
              <i v-else :class="item.icon"></i>
            </el-button>
          </template>
          <!-- btn -->
        </template>
      </el-table-column>
      <!-- 自定义 end -->
    </template>
  </el-table>
</template>

<script>
export default {
  props: {
    height: {
      required: false,
      type: Number
    },
    tableData: {
      required: true,
      type: Array
    },
    columns: {
      /*
      [
          {title, field, ...}
      ]
      */
      required: true,
      type: Array
    },
    // 多选框
    showCheckbox: {
      required: false,
      type: Boolean
    }
  },
  created() {
    this.timer = new Date().getTime()
  },
  data() {
    return {
      timer: ''
    }
  },
  methods: {
    // 多选
    handleSelectionChange(val) {
      console.log(val)
      this.$emit('multipleSelection', val)
    },
    // 删除标签
    handleClose(tag) {
      this.$emit('handleTagClose', tag)
      console.log(tag, '标签删除')
    },
    uploadFn(photos) {
      console.log(photos)
      this.$emit('uploadFn', photos)
      // this.$root.$emit('uploadFn', photos)
    },
    uploadClick(row) {
      console.log(row)
      this.$emit('uploadClick', row)
    }
  }
}
</script>

<style scoped>
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload .el-upload-dragger {
  width: 100%;
}

::v-deep .spanStyle {
  display: inline-block;
  white-space: nowrap;
  width: 200px;
  /* height: 100px; */
  overflow: hidden; /*超出的文本隐藏*/
  text-overflow: ellipsis; /* 溢出用省略号*/
}
</style>
